import { useMutation, useQuery } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { IPart } from "../models/Part";
import { DefaultResponseWithData } from "../models/system";

// What the condition box has always defaulted to, and the body of the base Condition Description
// template - used when the template can't be rendered.
export const DEFAULT_CONDITION_DESCRIPTION = "Used - ";

// eBay refuses a longer condition description; the API refuses to publish one too.
export const CONDITION_DESCRIPTION_MAX_LENGTH = 1000;

export default function useTemplateConditionDescription(part?: IPart, enabled: boolean = true) {
  const { get } = useApiHelper();

  // The customer's Condition Description template rendered for this part, to pre-fill an empty box.
  const conditionDescription = useQuery({
    queryKey: ["conditionDescription", part?.id],
    queryFn: () => get<DefaultResponseWithData<string>>(`/template/condition-description/${part?.id}`),
    staleTime: 1000 * 30,
    enabled: enabled && !!part?.id,
  });

  // Always fresh: re-applying is for picking up notes or a grade added since the offer was made.
  const renderConditionDescription = useMutation({
    mutationFn: (partId: string) => get<DefaultResponseWithData<string>>(`/template/condition-description/${partId}`),
  });

  return {
    conditionDescription,
    renderConditionDescription,
  };
}
